import type React from "react";
import "./Pill.scss";

type PillProps = {
  children: React.ReactNode;
  isSelected?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const Pill: React.FC<PillProps> = ({ children, isSelected, onClick, className, ...rest }) => {
  const selectedClass = isSelected ? "selected" : "";
  const clickableClass = onClick ? "pill--clickable" : "";

  return (
    <div {...rest} className={`pill ${selectedClass} ${clickableClass} ${className}`} onClick={onClick}>
      {children}
    </div>
  );
};
